import { tokenStore } from "../api/token";

export function PendingPage({ email }: { email?: string }) {
  return (
    <div className="auth-splash">
      <div className="auth-splash-card">
        <div className="auth-splash-title">Аккаунт ожидает одобрения</div>
        <div className="auth-splash-sub">
          {email ? (
            <>
              Вы вошли как <b>{email}</b>.
              <br />
            </>
          ) : null}
          Администратор ещё не выдал доступ. Попробуйте обновить страницу позже или попросите его
          одобрить ваш аккаунт.
        </div>
        <button
          className="auth-splash-action"
          onClick={() => {
            tokenStore.clear();
            window.location.href = "/login";
          }}
        >
          Войти другим аккаунтом
        </button>
      </div>
    </div>
  );
}
